import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
    adminApiUrl,
    getUserCredentials,
} from "../../axiosUtils"
import { FileProduct } from "../../../../redux/slices/authSlice"
import { ProductType } from "../../../../redux/slices/components/Marketplace/marketplaceDataSlice"

export type CreateProductMarketplace = {
    id: string
    productId: string
    description: string,
    price: number,
    File?: FileProduct
}

export const createProductMarketplace = (product: CreateProductMarketplace) => {
    return new Promise((resolve: (value: any) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.post(`${adminApiUrl}/v1/marketplace/product`, product, config)
            .then((res) => { 
                resolve(res.data.url)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/marketplace/product`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 

export type EditProductBody = {
    id: string,
    description: string
    price: number
    productId: string
    File?: FileProduct
}

export const editProductMarketplace = (product: EditProductBody) => {
    return new Promise((resolve: (value: any) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.patch(`${adminApiUrl}/v1/marketplace/product/${product.id}`, { ...product }, config)
            .then((res) => { 
                resolve(res.data.url)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/marketplace/product/${product.id}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const deleteProductMarketplace = (id: string) => {
    return new Promise((resolve: (value: any) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.delete(`${adminApiUrl}/v1/marketplace/product/${id}`, config)
            .then((res) => { 
                resolve(res.data.url)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/marketplace/product/${id}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const getLinkToPutFileProduct = (productId: string, Name: string) => {
    return new Promise((resolve: (value: any) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                params: { Name }
            };
            axios.post(`${adminApiUrl}/v1/marketplace/product/file/link/${productId}`, {}, config)
            .then((res) => { 
                resolve(res.data.link)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/marketplace/product/file/link/${productId}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const getLinkToDownloadFileProduct = (productId: string, Name: string, type: ProductType) => {
    return new Promise((resolve: (value: any) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                params: { Name, type }
            };
            axios.get(`${adminApiUrl}/v1/marketplace/product/file/${productId}/download`, config)
            .then((res) => { 
                resolve(res.data.link)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/marketplace/product/file/${productId}/download`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const getLinkToDownloadFileProductOtherUser = (userId: string, productId: string, Name: string, type: ProductType) => {
    return new Promise((resolve: (value: any) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                params: { Name, type, userId }
            };
            axios.get(`${adminApiUrl}/v1/products/file/${productId}/download/other-user`, config)
            .then((res) => { 
                resolve(res.data.link)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/products/file/${productId}/download/other-user`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 
